import { Grid, Typography } from '@mui/material';
import FieldText from '../../../../../components/general/fields/fieldText';
import FieldSelect from '../../../../../components/general/fields/fieldSelect';
import { useAccountContactPerson } from './hook';
import { AccountContactPersonProps } from './props';
import { Checkbox } from '../../../../../components/general/fields/checkbox';

export const AccountContactPerson = (props: AccountContactPersonProps) => {
    const { formik, typesDocument, genders, typesPerson, isJuridical } =
        useAccountContactPerson(props);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12}>
                <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                    Persona de contacto
                </Typography>
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Identificación"
                    name="document"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.document}
                    errors={formik.errors.document}
                    value={formik.values.document}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldSelect
                    data={typesPerson}
                    label="Tipo de persona"
                    name="personType"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.personType}
                    errors={formik.errors.personType}
                    value={formik.values.personType as string}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldSelect
                    data={typesDocument}
                    label="Tipo de documento"
                    name="typeDocument"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.typeDocument}
                    errors={formik.errors.typeDocument}
                    value={formik.values.typeDocument as string}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={isJuridical ? 12 : 8}>
                <FieldText
                    label={isJuridical ? 'Razón social' : 'Nombre'}
                    name="name"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.name}
                    errors={formik.errors.name}
                    value={formik.values.name}
                    onChange={formik.handleChange}
                />
            </Grid>
            {!isJuridical && (
                <Grid item xs={12} sm={4}>
                    <FieldText
                        label="Apellidos"
                        name="lastName"
                        size="small"
                        required
                        onBlur={formik.handleBlur}
                        touched={formik.touched.lastName}
                        errors={formik.errors.lastName}
                        value={formik.values.lastName}
                        onChange={formik.handleChange}
                    />
                </Grid>
            )}
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="E-mail"
                    name="email"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.email}
                    errors={formik.errors.email}
                    value={formik.values.email}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Celular"
                    name="cellPhone"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.cellPhone}
                    errors={formik.errors.cellPhone}
                    value={formik.values.cellPhone}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Teléfono"
                    name="phone"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.phone}
                    errors={formik.errors.phone}
                    value={formik.values.phone}
                    onChange={formik.handleChange}
                />
            </Grid>

            <Grid item xs={12} sm={4}>
                <FieldSelect
                    data={genders}
                    label="Género"
                    name="gender"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.gender}
                    errors={formik.errors.gender}
                    value={formik.values.gender as string}
                    onChange={isJuridical ? undefined : formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <Checkbox
                    isCheckMode={false}
                    beforeLabel="LGBTIQ"
                    label="¿Se identifica como LGBTIQ?"
                    data={[
                        { id: 'true', name: 'Sí' },
                        { id: 'false', name: 'No' },
                    ]}
                    checked={Boolean(formik.values.isLGBTIQ)}
                    onChange={(newValue) =>
                        formik.setFieldValue('isLGBTIQ', newValue)
                    }
                    onBlur={formik.handleBlur}
                    disabled={isJuridical}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <Checkbox
                    label="Activo"
                    checked={Boolean(formik.values.active)}
                    onChange={() => {
                        formik.setFieldValue('active', !formik.values.active);
                    }}
                />
            </Grid>
        </Grid>
    );
};
